var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCharge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 23,
    viewBox: "0 0 73 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON CHARGE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ROUND",
    d: "M16.4728 12.6514C16.4728 7.21537 12.1965 5.88657 8.67474 6.00737C5.65613 6.00737 0.876658 7.57771 1.00243 13.0137C1.12821 18.4497 5.02725 20.7449 9.30361 20.1409C13.58 19.5369 16.4728 18.0873 16.4728 12.6514Z",
    stroke: "#EF7056",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "ROUND_2",
    d: "M55.4693 7.61649C51.8166 11.6423 54.0908 15.5 56.7801 17.7769C59.0156 19.8053 63.6105 21.8539 67.1701 17.7435C70.7297 13.6331 69.3843 9.31337 65.8114 6.88717C62.2385 4.46096 59.1221 3.59063 55.4693 7.61649Z",
    stroke: "#EF7056",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "ROUND_3",
    d: "M27.2834 9.78547C27.6371 15.2099 31.9909 16.2576 35.4973 15.9079C38.5095 15.7114 43.1767 13.8334 42.6974 8.4171C42.2181 3.00082 38.178 0.964233 33.95 1.84525C29.722 2.72627 26.9296 4.36101 27.2834 9.78547Z",
    stroke: "#EF7056",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCharge);
export default __webpack_public_path__ + "static/media/icon-charge.feca910929611c0efcc4f65c79458085.svg";
export { ForwardRef as ReactComponent };